import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Text, Box } from 'pcln-design-system'

const Cell = styled(Box)`
  display: inline-block;
  vertical-align: top;
  line-height: 1.8;
  text-align: center;
  width: 100%;
  height: 50px;
  border-radius: 6px;
  &:hover {
    background: transparent;
  }
`

const Price = styled(Text)`
  color: ${(props) => props.isSelected && props.theme.colors.white};
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
`

const getColor = (props) => {
  if (!props.isValid || !props.showColor) {
    return null
  } else if (props.isSelected) {
    return 'primary.base'
  } else if (props.isGrouped) {
    return 'primary.light'
  } else if (!props.customDayProps) {
    // mark day with yellow if no data for specific day
    return 'caution.light'
  } else if (props.customDayProps.price < props.lowestPrice + 50) {
    return 'pricePrimary.light'
  } else if (props.customDayProps.price < props.lowestPrice + 100) {
    return 'caution.light'
  }
  return 'warning.light'
}

const currency = '$'

const CustomDayWithColorCode = (props) => {
  const { day, customDayProps, isValid, isSelected } = props
  const displayedPrice = isValid && customDayProps ? `${currency}${customDayProps.price}` : ''

  const color = getColor(props)

  return (
    <Cell data-testid={color} color={color}>
      <Text bold fontSize={2}>
        {day}
      </Text>
      {displayedPrice && (
        <Price color='text.base' isSelected={isSelected}>
          {displayedPrice}
        </Price>
      )}
    </Cell>
  )
}

CustomDayWithColorCode.propTypes = {
  day: PropTypes.string.isRequired,
  isValid: PropTypes.bool,
  isSelected: PropTypes.bool,
  isGrouped: PropTypes.bool,
  customDayProps: PropTypes.shape({
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  showColor: PropTypes.bool,
}

export default CustomDayWithColorCode
